import { hot } from 'react-hot-loader';

import Card1Icon from './SvgRobo/Card1Icon';
import Card2Icon from './SvgRobo/Card2Icon';
import Card3Icon from './SvgRobo/Card3Icon';
import Card4Icon from './SvgRobo/Card4Icon';
import Card5Icon from './SvgRobo/Card5Icon';
import Card6Icon from './SvgRobo/Card6Icon';

import './Card.scss';



// poster - 192x192
// posterhd - 384x384
function Card({ poster, posterhd, name, summ, icon1, icon2, className }) {
  if (poster)
    return (
      <div className={"card " + className} >
        <div className="card-overlay"></div>
        <div className="card-item">
          <div className="card-item__image">
            {!posterhd && <img
              src={poster}
              alt="" title="" width="192" height="192"
              className="img-responsive"
            />}
            {posterhd && poster && <img
              src={poster} srcSet={posterhd}
              alt="" title="" width="192" height="192"
              className="img-responsive"
            />}
          </div>
          <div className="card-item__info">
            <div className="card-item__info-row">
              <div className="card-item__info-col1">
                <span className="card-item__info-name">{name}</span>
                {summ && <div>{summ} ETH</div>}
              </div>
              <div className="card-item__info-col2">
                {icon1 === '1' && <div className="card-item__icon card-item__icon--1"><Card1Icon /></div>}
                {icon1 === '2' && <div className="card-item__icon card-item__icon--2"><Card2Icon /></div>}
                {icon1 === '3' && <div className="card-item__icon card-item__icon--3"><Card3Icon /></div>}
                {icon2 === '4' && <div className="card-item__icon card-item__icon--4"><Card4Icon /></div>}
                {icon2 === '5' && <div className="card-item__icon card-item__icon--5"><Card5Icon /></div>}
                {icon2 === '6' && <div className="card-item__icon card-item__icon--6"><Card6Icon /></div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );

  return (null);
};

export default hot(module)(Card);
